import { Model } from "../Components/Models/Model";


class LoaderController extends Model {
    private _loading: boolean = true

    setLoading = (bool: boolean) => {
        if(this._loading === bool){
            return;
        }
        this._loading = bool
        this.updateMe()
    }

    show = () => {
        this.setLoading(true)
    }

    hide = () => {
        this.setLoading(false)
    }

    get loading(){
        return this._loading
    }
}

export { LoaderController }